export default function registerPolyfills() {
  if (typeof Element.prototype.matches !== 'function') {
    // element-closest | CC0-1.0 | github.com/jonathantneal/closest

    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function matches(selector) {
        const element = this;
        const elements = (
          element.document || element.ownerDocument
        ).querySelectorAll(selector);
        let index = 0;

        while (elements[index] && elements[index] !== element) {
          index += 1;
        }

        return Boolean(elements[index]);
      };
  }

  if (typeof Element.prototype.closest !== 'function') {
    Element.prototype.closest = function closest(selector) {
      let element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
}
